import React, { Component } from 'react'
import Helmet from 'react-helmet'

class Favicon extends Component {
	render() {
		return (
			<Helmet>
				<link rel="apple-touch-icon-precomposed" sizes="57x57" href={require('./apple-touch-icon-57x57.png')} />
				<link rel="apple-touch-icon-precomposed" sizes="114x114" href={require('./apple-touch-icon-114x114.png')} />
				<link rel="apple-touch-icon-precomposed" sizes="72x72" href={require('./apple-touch-icon-72x72.png')} />
				<link rel="apple-touch-icon-precomposed" sizes="144x144" href={require('./apple-touch-icon-144x144.png')} />
				<link rel="apple-touch-icon-precomposed" sizes="60x60" href={require('./apple-touch-icon-60x60.png')} />
				<link rel="apple-touch-icon-precomposed" sizes="120x120" href={require('./apple-touch-icon-120x120.png')} />
				<link rel="apple-touch-icon-precomposed" sizes="76x76" href={require('./apple-touch-icon-76x76.png')} />
				<link rel="apple-touch-icon-precomposed" sizes="152x152" href={require('./apple-touch-icon-152x152.png')} />
				<link rel="icon" type="image/png" href={require('./favicon-196x196.png')} sizes="196x196" />
				<link rel="icon" type="image/png" href={require('./favicon-96x96.png')} sizes="96x96" />
				<link rel="icon" type="image/png" href={require('./favicon-32x32.png')} sizes="32x32" />
				<link rel="icon" type="image/png" href={require('./favicon-16x16.png')} sizes="16x16" />
				<link rel="icon" type="image/png" href={require('./favicon-128.png')} sizes="128x128" />
				<link rel="shortcut icon" href="favicon.ico" />
				<meta name="msapplication-TileImage" content={require('./mstile-144x144.png')} />
				<meta name="msapplication-square70x70logo" content={require('./mstile-70x70.png')} />
				<meta name="msapplication-square150x150logo" content={require('./mstile-150x150.png')} />
				<meta name="msapplication-wide310x150logo" content={require('./mstile-310x150.png')} />
				<meta name="msapplication-square310x310logo" content={require('./mstile-310x310.png')} />
			</Helmet>
		)
	}
}

export default Favicon


// WEBPACK FOOTER //
// ./src/components/Favicon/Favicon.js